import { render } from "./CookiesImageInput.vue?vue&type=template&id=51d57c59&scoped=true&ts=true"
import script from "./CookiesImageInput.vue?vue&type=script&lang=ts"
export * from "./CookiesImageInput.vue?vue&type=script&lang=ts"

import "./CookiesImageInput.vue?vue&type=style&index=0&id=51d57c59&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d57c59"]])

export default __exports__